export default __webpack_public_path__ + "static/media/IkonHjerte.3b4a50fd.svg";